import React from "react";
import { CSVLink } from "react-csv";
import * as Styled from "./styles";
import {
  GODate,
  GOButton,
  GODropbox,
  GOFilterContainer
} from "../../../components";
import { UserManager } from "../../../actions";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const Filter = ({
  filter,
  setFilter,
  changeFilter,
  setPurchase,
  purchase,
  data
}: any) => {
  const { t } = useTranslation();

  const statusFormat = (status: number) => {
    if (status === 0) {
      return t("accounting.incompletedPayment");
    } else if (status === 1) {
      return t("accounting.payment_short");
    } else if (status === 2) {
      return t("accounting.refund_short");
    } else if (status === 3) {
      return t("accounting.deleted_short");
    } else {
      return "";
    }
  };

  let excelData = [];
  try {
    excelData =
      data.transactions !== undefined && Array.isArray(data.transactions)
        ? data.transactions.map((t: any) => {
            try {
              return {
                no: t.no,
                purchaseDate: dayjs(t.purchaseDate).format("YYYY-MM-DD"),
                username: t.username,
                phoneNumber: t.phoneNumber,
                ticketName: t.ticketName,
                status: statusFormat(t.status),
                originalPrice: t.originalPrice,
                discount: t.discount,
                unpaidPrice: t.unpaidPrice,
                paidAmount: t.paidAmount,
                refund: t.refund,
                employee: t.employee,
                transactionMemo: t.transactionMemo
              };
            } catch (e) {
              console.log(e);
              return {
                no: "",
                purchaseDate: "",
                username: "",
                phoneNumber: "",
                ticketName: "",
                status: "",
                originalPrice: "",
                discount: "",
                unpaidPrice: "",
                paidAmount: "",
                refund: "",
                employee: "",
                transactionMemo: ""
              };
            }
          })
        : [];
  } catch (e) {
    console.log(e);
  }
  return (
    <GOFilterContainer
      leftbody={
        <>
          <Styled.DateWrapper>
            <h5>{t("accounting.period")}</h5>
            <Styled.DateBox>
              <GODate
                startDate={new Date(filter.startDate)}
                endDate={new Date(filter.endDate)}
                onChange={(data: any) => {
                  setFilter({ ...filter, type: null, startDate: data });
                }}
                selected={new Date(filter.startDate)}
                required
              />
            </Styled.DateBox>
            <span>~</span>
            <Styled.DateBox>
              <GODate
                startDate={new Date(filter.startDate)}
                endDate={new Date(filter.endDate)}
                onChange={(data: any) => {
                  setFilter({ ...filter, type: null, endDate: data });
                }}
                selected={new Date(filter.endDate)}
                required
              />
            </Styled.DateBox>
          </Styled.DateWrapper>
          <Styled.ControlWrapper>
            <GOButton
              body={t("common.yesterday")}
              buttontype={filter.type === -1 ? "green" : undefined}
              onClick={() => changeFilter(-1)}
            />
            <GOButton
              body={t("common.today")}
              buttontype={filter.type === 0 ? "green" : undefined}
              onClick={() => changeFilter(0)}
            />
            <GOButton
              body={t("common.this_week")}
              buttontype={filter.type === 1 ? "green" : undefined}
              onClick={() => changeFilter(1)}
            />
            <GOButton
              body={t("common.this_month")}
              buttontype={filter.type === 2 ? "green" : undefined}
              onClick={() => changeFilter(2)}
            />
            <GOButton
              body={t("trans.lastMonth")}
              buttontype={filter.type === 3 ? "green" : undefined}
              onClick={() => changeFilter(3)}
            />
          </Styled.ControlWrapper>
        </>
      }
      rightbody={
        <Styled.RightFilterWrapper>
          {UserManager().getUser()?.branch.id === -1 && (
            <Styled.DropboxWrapper>
              <div className="label">지점 선택</div>
              <GODropbox
                data={[
                  { body: "선택하세요", value: -1 },
                  { body: "훈련소 전체", value: 0 },
                  { body: "Cambodia", value: 2 }
                ]}
                value={filter.branchID}
                onChange={(e: any) =>
                  setFilter({ ...filter, branchID: parseInt(e.target.value) })
                }
                xsmall
                isDefault
              />
            </Styled.DropboxWrapper>
          )}
          <Styled.DropboxWrapper>
            <div className="label">
              {t("components.accounting.filter.gender")}
            </div>
            <GODropbox
              data={[
                { body: t("components.accounting.filter.all"), value: 2 },
                { body: t("components.accounting.filter.male"), value: 0 },
                { body: t("components.accounting.filter.female"), value: 1 }
              ]}
              value={filter.sex}
              onChange={(e: any) =>
                setFilter({ ...filter, sex: e.target.value })
              }
              xsmall
            />
          </Styled.DropboxWrapper>
          <Styled.DropboxWrapper>
            <div className="label">
              {/*나이대*/}
              {t("components.accounting.filter.ageGroup")}
            </div>
            <GODropbox
              data={[
                { body: t("components.accounting.filter.all"), value: 0 },
                { body: t("components.accounting.filter.10s"), value: 1 },
                { body: t("components.accounting.filter.20s"), value: 2 },
                { body: t("components.accounting.filter.30s"), value: 3 },
                { body: t("components.accounting.filter.40s"), value: 4 },
                { body: t("components.accounting.filter.50s"), value: 5 },
                { body: t("components.accounting.filter.60s"), value: 6 },
                { body: t("components.accounting.filter.70s"), value: 7 }
              ]}
              value={filter.age}
              onChange={(e: any) =>
                setFilter({ ...filter, age: e.target.value })
              }
              xsmall
            />
          </Styled.DropboxWrapper>
          <CSVLink
            headers={[
              { label: t("components.accounting.filter.number"), key: "no" },
              { label: t("csv.purchaseDate"), key: "purchaseDate" },
              { label: t("csv.name"), key: "username" },
              { label: t("csv.phone"), key: "phoneNumber" },
              { label: t("csv.details"), key: "ticketName" },
              { label: t("csv.status"), key: "status" },
              { label: t("csv.originalPrice"), key: "originalPrice" },
              { label: t("csv.discount"), key: "discount" },
              { label: t("csv.unpaidPrice"), key: "unpaidPrice" },
              { label: t("csv.paidAmount"), key: "paidAmount" },
              { label: t("csv.refund"), key: "refund" },
              { label: t("csv.personInCharge"), key: "employee" },
              { label: t("csv.paymentMemo"), key: "transactionMemo" }
            ]}
            data={excelData}
            filename={`sales.csv`}
            target="_blank"
          >
            <GOButton
              body={t("components.accounting.filter.downloadExcel")}
              onClick={() => {}}
            />
          </CSVLink>
        </Styled.RightFilterWrapper>
      }
    >
      <Styled.SegmentBox state={purchase}>
        <div
          className="totalPurchase"
          onClick={() => {
            setPurchase((prevState: boolean) => {
              if (prevState) return false;
            });
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
          }}
        >
          {t("components.accounting.filter.totalSale")}
        </div>
        <div
          className="newPurchase"
          onClick={() => {
            setPurchase((prevState: boolean) => {
              if (!prevState) return true;
            });
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
          }}
        >
          {/*신규 매출*/}
          {t("components.accounting.filter.totalNewSale")}
        </div>
      </Styled.SegmentBox>
    </GOFilterContainer>
  );
};

export default Filter;
